import RoundCheckBoxSmall from './RoundCheckBoxSmall';

export default RoundCheckBoxSmall;
